import service from '../http';

/**
 * Get coupon template list
 * @param {Function} callBack - Callback function after successful retrieval
 */
export const getCouponTemplateList = async (callBack) => {
  await service.get(`/newapi/tax/couponTemplate/list`).then(({ data: res }) => {
    callBack && callBack(res);
  });
};

/**
 * Get user's coupon list
 * @param {Object} param - Query parameters object
 * @param {Function} callBack - Callback function after successful retrieval
 */
export const userCouponlist = async (param = {}, callBack) => {
  await service.post(`/newapi/tax/userCoupon/list`, param).then(({ data: res }) => {
    callBack && callBack(res);
  });
};
